import Notifications from 'vue-notification' // Vue plugin

export class NotificationPlugin {
  static install(Vue, _options) {
    Vue.use(Notifications) // establishes Vue.notify and Vue.prototype.$notify
    // Vue.prototype.$notify = Vue.notify
  }
}
